import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["href"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'NewsListItemContentLink',
    props: {
        link: {},
        category: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("a", {
                class: _normalizeClass(["filterable-list__list-item-link", `is-${_ctx.category}`]),
                href: _ctx.link?.href
            }, _toDisplayString(_ctx.link?.text), 11 /* TEXT, CLASS, PROPS */, _hoisted_1));
        };
    }
});
